import React, { useEffect, useState } from "react";
import { doc, getDoc } from "firebase/firestore";
import { db } from "../../../firebase";
import { Navbar } from "../../../Components/Navbar/Navbar";
import { Footer } from "../../../Components/Footer/footer";
import { Link, useLocation } from "react-router-dom";
import "./style.css";

interface PodcastEpisode {
  id: string;
  title: string;
  description: string;
  date: string;
  youtube_url: string;
  image_url?: string;
}

export function PodcastPage() {
  const [headerImage, setHeaderImage] = useState("");
  const [episodes, setEpisodes] = useState<PodcastEpisode[]>([]);
  const location = useLocation();

  useEffect(() => {
    const fetchData = async () => {
      const ref = doc(db, "site_content", "podcast_page");
      const snap = await getDoc(ref);
      if (snap.exists()) {
        const data = snap.data();
        setHeaderImage(data.header_image || "");
        const sortedEpisodes = (data.episodes || []).sort(
          (a: PodcastEpisode, b: PodcastEpisode) =>
            new Date(b.date).getTime() - new Date(a.date).getTime()
        );
        setEpisodes(sortedEpisodes);
      }
    };
    fetchData();
  }, []);

  return (
    <div className="page-container">
      <Navbar />
      {headerImage && (
        <div
          className="podcast-banner"
          style={{ backgroundImage: `url(${headerImage})` }}
        />
      )}
      <div className="page-content">
        <h1>Episoade Podcast</h1>
        <div className="podcast-grid">
          {episodes.map((ep) => (
            <Link
              to={`/podcast/${ep.id}${
                new URLSearchParams(location.search).get("admin") === "true" ? "?admin=true" : ""
              }`}
              key={ep.id}
              className="podcast-card"
            >
              {ep.image_url && (
                <img src={ep.image_url} alt={ep.title} className="podcast-thumb" />
              )}
              <h3>{ep.title}</h3>
              <p className="podcast-date">
                {new Date(ep.date).toLocaleDateString("ro-RO", {
                  day: "numeric",
                  month: "long",
                  year: "numeric",
                })}
              </p>
            </Link>
          ))}
        </div>
      </div>
      <Footer />
    </div>
  );
}
